/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-16 15:53:42
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-23 17:03:03
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorHeader/index.tsx
 */
import RouteBlock from '@/src/constrains/SalesChannelPreviewPageComponents/BasicPageHOC/RouteBlock';
import { RightConfigWrapper } from '@/src/layout';
import React from 'react';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';
import { dispatch } from 'src/store';
import PageWrapper from '../../../constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import HeaderStyle from './HeaderStyle';
import HoverStyle from './HoverStyle';
import PromotionBarStyle from './PromotionBarStyle';

import { useParams } from 'react-router-dom';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { IParams } from '../common';
import PromotionBarContent from './PromotionBarContent';
import ScrollEffect from './ScrollEffect';
import {
  fetchHeader,
  getHasModified,
  getLoaded,
  getSalesChannel,
  getSalesChannelName,
  getState,
  submitHeader,
  validation,
} from './slice';
import styles from './style.module.less';
import { convertDataFromReduxToServer } from './tool';
function SalesChannelEditorHeader(props: any) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    // currentStyle,
    isOnPrimaryLanguage,
    loaded,
  } = props;
  const _params: IParams = useParams();
  const { contentUuid } = _params;
  return (
    <React.Fragment>
      <RouteBlock hasModified={hasModified} />
      <PageWrapper
        withoutCollapse
        hideRightPart
        headerConfig={{
          hasModified,
          submit: submitData,
          salesChannelContentData: salesChannel || {},
          salesChannelName: salesChannelName,
          onDiscard,
          onGoBack,
        }}
        leftChild={
          loaded ? (
            <RightConfigWrapper
              wrapperClassName={styles.wrapper}
              title={getI18n('general.sider.header')}
              elements={[
                {
                  body: (
                    <React.Fragment>
                      {isOnPrimaryLanguage && (
                        <div className={styles.item}>
                          <PromotionBarStyle
                            isResponsive
                            contentUuid={contentUuid}
                          />
                          <HeaderStyle isResponsive />
                          <HoverStyle isResponsive />
                          <ScrollEffect isResponsive />
                        </div>
                      )}
                    </React.Fragment>
                  ),
                  key: 'headerTop',
                },
                {
                  body: (
                    <React.Fragment>
                      <PromotionBarContent
                        isResponsive
                        contentUuid={contentUuid}
                        isOnPrimaryLanguage={isOnPrimaryLanguage}
                      />
                    </React.Fragment>
                  ),
                  key: 'headerBottom',
                },
              ]}
            />
          ) : null
        }
      />
    </React.Fragment>
  );
}

export default BasicPageHOC(SalesChannelEditorHeader, {
  getState,
  previewSizeInParams: true,
  convertDataFromReduxToServer,
  submit: submitHeader,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  getLoaded,
  validation,
  queryData: (params, qParams) => {
    const { contentUuid } = params;
    dispatch(
      fetchHeader({
        uuid: contentUuid,
        params: qParams,
      }),
    );
  },
});
